
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvBookingTicketCapacity.html?raw';
import { EvBookingCopyForm } from "../../_loadingHelpers/VAMv2";
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import "../../../moreCore/UI/NumberInput/NumberInput";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
class EvBookingTicketCapacity extends compose(_StatefulSection) {
    templateString: any = template;

    ticketsCapacity: MdsLax<InstanceType<typeof NumberInput>>;
    ticketsEstimated: MdsLax<InstanceType<typeof NumberInput>>;

    onNewSeatingLayout(data: VAM2types.AudienceSeatingLayout, dlgResult: number = null) {
        let currentData = this.currentData as VAM2types.EvBooking_Extended;

        if (data && data.seating_capacity > 0 && data.seating_capacity != currentData.tickets_capacity) {
            if (dlgResult == null) {
                let dlg = new GenericDialog();
                dlg.show(this.translations["BookingEditor_UseCapacityFromSeatingLayout"],
                    this.translations["BookingEditor_UseCapacityFromSeatingLayout__Header"],
                    "",
                    "",
                    "yesno", lang.hitch(this, this.onNewSeatingLayout, data)
                );
                return;
            }
            if (dlgResult == 2) {

                //this.ticketsCapacity.domNode.scrollIntoView({ behavior: "smooth" });
                this.setAttributeValue("tickets_capacity", data.seating_capacity);

                setTimeout(() => {
                    this.UiModder.domClass.add(this.ticketsCapacity.domNode, "mds-shake");
                }, 400);

                setTimeout(() => {
                    this.UiModder.domClass.remove(this.ticketsCapacity.domNode, "mds-shake");
                }, 3000);
            }
        }
    }

    afterSetData() {
        let data = this.sourceData as VAM2types.EvBooking_Base;
    }

    onDirtyChange(currentState: boolean) {
        
    }

    _onChanged(key: string, value: any) {
        //this.setStylesBasedOnData(); // bissl extrem? wird bei jeder kleinen Änderung aufgerufen

        if (key == "tickets_capacity" || key == "tickets_estimated") {
            this.UiModder.domClass.toggle(this.domNode, "warningYellowBG", this.ticketsCapacity.getValue() < this.ticketsEstimated.getValue());
        }
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.ticketsCapacity.setPlaces(0);
        this.ticketsEstimated.setPlaces(0);
    }
    startup(): void {
        if (!this.hasFeature("EvBooking/TicketsCapacity")) return;
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvBookingTicketCapacity);